export const DEMO_TOKEN_KEY = 'omniscope:demoToken';
export const DEMO_INFO_KEY = 'omniscope:demoInfo';

export function getDemoToken() {
  try {
    const t = window.localStorage.getItem(DEMO_TOKEN_KEY);
    return String(t || '').trim();
  } catch {
    return '';
  }
}

export function getDemoInfo() {
  try {
    const raw = window.localStorage.getItem(DEMO_INFO_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function isDemoActive() {
  return Boolean(getDemoToken());
}

export function setDemoSession({ token, demo } = {}) {
  const t = String(token || '').trim();
  if (!t) return false;
  try {
    window.localStorage.setItem(DEMO_TOKEN_KEY, t);
    if (demo && typeof demo === 'object') {
      window.localStorage.setItem(DEMO_INFO_KEY, JSON.stringify(demo));
    } else {
      window.localStorage.removeItem(DEMO_INFO_KEY);
    }
    return true;
  } catch {
    return false;
  }
}

export function clearDemoSession() {
  try {
    window.localStorage.removeItem(DEMO_TOKEN_KEY);
    window.localStorage.removeItem(DEMO_INFO_KEY);
  } catch {
    // ignore
  }
}

